<template>

  <div>
    <div class="infor fl newcontent">
      <div class="infor-t clearfix">
  
        <div >
            <div class="ptitle">缴纳会费</div>
            
            <div>
              <div class="dialog" v-if="isrenew == true" style="max-width:800px;font-size:20px">
                <h3 class="renewtimeout">会员截止日期：</h3>
                <div class="renewtime">
                  <p>{{ member.end_at }}</p>
                </div>
                <p class="pcontent">
                  尊敬的{{ state_text }}：
                   <div style="text-indent: 20px;text-align:left;">根据《贵州省建筑业协会会费收取及使用管理暂行办法》，为确保会员单位资质信息以及顺利开展各项工作，请于会员截止日期前缴纳会费。</div>
                </p>
                <div class="renewradio">
                  <div class="renewradio_title">选择支付方式：</div>
                  <div class="renewradio_content">
                    <el-radio-group
                      v-model="pay_type"
                      size="small"
                    >
                      <el-radio :label="1" ><span class="eradio">对公支付</span></el-radio>
                      <el-radio :label="0" ><span class="eradio">个人支付</span></el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="btn" @click="gorenew">
                  <p>去续费</p>
                </div>
                <div class="btip">缴费成功后，可到”缴费记录”菜单申请发票</div>
              </div>
              <div class="dialog" v-if="isrenew == false">
                <img
                  style="width: 153px; height: 140px"
                  src="../assets/faile.png"
                  alt
                />
                <p style="color: #333333; font-size: 20px">证书有效期截止提醒</p>
                <p style="margin-top: 7px">请在证书有效期截止前完成续费</p>
                <div class="knowbtn" @click="know">
                  <p>知道了</p>
                </div>
              </div>
            </div>
            <el-dialog
              :close-on-click-modal="false"
              :visible.sync="dialogVisiblepay"
              width="30%"
            >
              <div style="display: flex; flex-direction: column; align-items: center">
                <p style="font-size: 16px; color: #333333">请扫下方二维码完成缴费</p>
                <!-- <div id="qrCode" ref="qrCodeDiv" :style="{backgroundImage:'url('+wechat+')'}"></div> -->
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-evenly;
                  "
                >
                  <!-- <div class="zhifu">
                    <svg class="icon svg-icon" aria-hidden="true" v-html="wechat">
                      <svg xmlns="http://www.w3.org/2000/svg" width="300" />
                    </svg>
                    <img
                      style="width: 40px; height: 40px"
                      src="../assets/weixin.png"
                      alt
                    />
                  </div> -->
                  <div class="zhifu">
                    <svg class="icon svg-icon" aria-hidden="true" v-html="ccb">
                      <svg xmlns="http://www.w3.org/2000/svg" />
                    </svg>
                    <img
                      style="width: 50px; height: 50px"
                      src="../assets/ccb.jpeg"
                      alt
                    />
                  </div>
                  <use xlink:href="#icon-houcangguanlisvg"></use>
                </div>
                <!-- <div style="width:100%;display: flex;justify-content: space-evenly;transform: translateY(-40px);">
                  <img style="width:40px;height:40px" src="../../assets/weixin.png" alt />
                  <img style="width:40px;height:40px" src="../../assets/zhifubao.png" alt />
                </div>-->
        
                <el-button style="color: #194abe; width: 90%" @click="ispaye()"
                  >已确定扫码成功</el-button
                >
              </div>
            </el-dialog>
        
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Members from "../components/Members"
import { GetMember, GetBaseURL } from "../utils/api.js";
import { Base64 } from "js-base64";
import {
  myOrder,
  Apply,
  ApplyInfo,
  renewOrder, //支付
} from "../utils/api.js";

export default {
  name: "renew",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
        applayoverdue:true,//会员是否到期
      defultuserimg:require('../assets/6880@2x.png'),
      isrenew: null,
      state_text: "会员单位",
      code: 0,
      member: {},
      info: {},
      dialogVisible: false,
      dialogVisiblepay: false,
      Certificate: GetBaseURL +"GetUserCertificate/",
      dialogShowCertificate: false,
      wechat: "", //微信支付二维码
      alipay: "", 
      ccb: "",
      ccb_corporate_url: "", // 对公链接

      order_id: '',
      pay_type: 1, // 1=对公
    };
  },
  created(){
    this.getmember();
  },
   async mounted() {
    this.initData();
  },
  methods: {
      async getmember() {
          let info = await ApplyInfo();
          this.info = info;
          let member = await GetMember();
           switch (member.level) {
            case 1:
              this.state_text = "会员单位";
              break;
            case 2:
              this.state_text = "理事单位";
              break;
            case 3:
              this.state_text = "常务理事单位";
              break;
            case 4:
              this.state_text = "副会长单位";
              break;
          }
          if(member.is_expired == 1){
              this.renew();
          } else {
              this.$router.push({
        			path: '/member/infor',
        		});
        		return ;
          }
          let applaytime = new Date(member.end_at).getTime()
          let nowtime = new Date().getTime()
          if (nowtime-applaytime>=0) {
            this.applayoverdue = false
          }else{
            this.applayoverdue = true
          }
          this.$store.commit('isapplayoverdue',this.applayoverdue)
          member.end_at?member.end_at = member.end_at.slice(0,10):''
          this.member = member;
          
          this.$store.commit('isprize',member.level)
          this.$forceUpdate();
        },
        async initData() {
          let info = await ApplyInfo();
          this.info = info;
        },
        checkOrder(order_id) {
          let timer = null;
          let timeout = 0;
          timer = setInterval(() => {
            timeout++;
            myOrder(order_id).then((res) => {
              if (res.pay_status == 1) {
                this.ispaye();
                this.dialogVisiblepay = false;
                clearInterval(timer);
                this.getmember();
                this.initData();
              }
            });
            if (timeout >= 30) {
              this.ispaye();
              clearInterval(timer);
              this.dialogVisiblepay = false;
              this.getmember();
              this.initData();
            }
            if (this.dialogVisible == false && this.dialogVisiblepay == false) {
              clearInterval(timer);
            }
          }, 1000);
        },
        ispaye() {
          this.dialogVisiblepay = false;
          this.dialogVisible = false;
        },
        //打开支付弹框
        gorenew() {
          this.dialogVisible = false;
          if (this.pay_type == 1) {
            window.open(this.ccb_corporate_url, '_blank');
          } else {
            this.dialogVisiblepay = true;
          }
          this.checkOrder(this.order_id)
        },
        //知道了
        know() {
          this.dialogVisible = false;
          this.dialogVisiblepay = false;
        },
        //续费
        renew() {
          let that = this;
          this.dialogVisible = true;
          this.dialogVisiblepay = false;
          renewOrder().then(
            (res) => {
              this.isrenew = true;
              this.order_id = res.order_id;
              this.ccb = Base64.decode(res.ccb);
              this.ccb_corporate_url = res.ccb_corporate_url;
            },
            (err) => {
              this.isrenew = false;
              console.log(err);
            }
          );
        },
        gopath(name, title, index) {
            console.log(name,'gopath')
          this.code = parseInt(index);
          // let pathname='member/'+name;
          this.$router.push({
            path: name,
            query: {
              name: title,
            },
          });
        },
        cheght(item) {
          const fjjrjk = this.navItem.findIndex((val) => {
            console.log(999, item.path, val.name);
            return item.path.indexOf(val.name) != -1;
          });
          this.code = parseInt(fjjrjk);
        },
        onApplyTap() {
          this.$router.push({
            path: "apply",
          });
        },
        // 跳转修改资料
        onMemberTap() {
          this.$router.push({
            path: "infor",
          });
        },
    
      printNewWindow(imgSrc) {
      let oWin = window.open('', 'pringwindow', 'menubar=no,location=no,resizable=yes,scrollbars=no,status=no,width=1000,height=660')
      oWin.document.fn = function() {
          if (oWin) {
              oWin.print()
              oWin.close()
          }
      }
      let html = '<div style="height: 100%;width: 100%;">' + `<img src="${imgSrc}" onload="fn()" style="max-height:100%;max-width: 100%;" />` + '</div>'
      oWin.document.open()
      oWin.document.write(html)
      oWin.document.close()
      },
    
    downloadIamge(imgsrc, name) {
      var image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png");
    
          var a = document.createElement("a");
          var event = new MouseEvent("click");
          a.download = name || "photo";
          a.href = url;
          a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
  }
};
</script>
<style lang="less" scoped>
.c-l {
  float: left;
  width: 268px;

  &-t {
    width: 268px;
    height: 328px;
    background: url("../assets/16.png");
    background-repeat: no-repart;
    background-size: cover;

    &-a {
      width: 117px;
      height: 117px;
      border-radius: 50%;
      margin-top: 30px;
    }
    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 268px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        display: inline-block;
        float: left;
      }
    }
    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      color: #fff;
      font-size: 16px;
      width: 99px;
      height: 24px;
      background: linear-gradient(270deg, #e51725 0%, #730c13 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
      margin: 0 auto;
      margin-top: 10px;
    }
    &-i {
      display: inline-block;
      float: left;
    }
    &-t {
      color: #ffffff;
      font-size: 14px;
      opacity: 0.6;
      margin-top: 10px;
    }
    &-b {
      width: 76px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid #ffffff;
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  &-b {
    width: 268px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;
    &-item {
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #7c828a;
      font-size: 18px;
      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }
}
.infor {
  &-t {
    // padding: 14px;
    padding-top: 14px;
    border-bottom: 1px solid #d4dbdd;

    &-l {
      font-size: 28px;
      color: #181e23;
      display: inline-block;
      padding-bottom: 14px;
      font-weight: bold;
      border-bottom: 2px solid #194abe;
    }

    &-r {
      width: 104px;
      height: 31px;
      background: #194abe;
      border: 1px solid #d4dbdd;
      opacity: 1;
      overflow: hidden;
      display: table-cell;
      line-height: 31px;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      span {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  &-c {
    text-align: justify;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #565656;
    padding: 10px 0px;
  }

  &-img {
    text-align: center;
    padding: 24px 0px 40px 0px;
  }
}
.dialog {
  max-width: 454px;
  padding: 0 46px;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto 20px;
}
.btn,
.knowbtn {
  cursor: pointer;
  margin: 0 auto;
  margin-top: 18px;
  max-width: 177px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #194abe;
  opacity: 1;
  border-radius: 4px;
  p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 45px;
    color: #194abe;
  }
}
.knowbtn {
  border: 1px solid #7c828a;
  margin-top: 43px;
  p {
    color: #7c828a;
  }
}
.renewtimeout {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #333333;
}
.content {
  margin-top: 16px;
  text-align: start;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #7c828a;
}
.renewtime {
  margin: 0 auto;
  max-width: 224px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 45px;
    color: #e51725;
  }
}
.renewradio {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;

  .renewradio_title {
    color: #409EFF;
    font-weight: bold;
  }
}
.c-l-t-i-m {
  width: 29px;
  height: 21px;
}

.c-l {
  float: left;

  &-t {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../assets/16.png");
    background-repeat: no-repart;
    background-size: cover;
    padding-bottom: 20px;
    &-a {
      width: 222px;
      height: 117px;
      margin-top: 30px;
    }

    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 268px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: inline-block;
        max-width: 222px;
      }
    }

    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
      height: 24px;
      margin: 0 auto;
      margin-top: 10px;
      padding: 5px 10px;
    }
    &-g-applay{
      background: linear-gradient(270deg, #e51725 0%, #730c13 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
    }
    &-g-overdue{
      background: linear-gradient(270deg, #E4E4E4 0%, #B4B4B4 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
    }

    &-d {
      background: #a4aab5 !important;
    }

    &-i {
      display: inline-block;
      float: left;
      cursor: pointer;
    }

    &-t {
      color: #ffffff;
      font-size: 14px;
      opacity: 0.6;
      margin-top: 10px;
    }

    &-b {
      // width: 76px;
      padding: 0px 10px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid #ffffff;
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  &-b {
    width: 268px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;

    &-item {
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #7c828a;
      font-size: 18px;

      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }

  .active {
    background: url("../assets/linhe.png");
    background-repeat: no-repart;
    background-size: contain;
    border-left: 5px solid #194abe;
    color: #194abe;
    font-weight: bold;

    span {
      border: none;
    }
  }
}
.newcontent {
    padding-bottom:30px;
    background-color: #fff;
}
.ptitle {
    padding:20px;
    font-size:28px;
    font-weight:bold;
    color:#000
}
.footer {
    width: 100% !important;
    position: fixed !important;
    bottom:0px;
}
.pcontent {
    font-size:20px;
    text-align: left;
    margin:20px 0px;
    line-height: 35px;
}
.btip {
    width: 100%;
    text-align: center;
    margin:16px 0px;
    font-size:16px !important;
}
.eradio {
    font-size:16px !important;
}
.eradio .el-radio__label {
    font-size:16px !important;
}
</style>
